(function() {
  'use strict';

  var AUTOSCROLL_INTERVAL = 4000;
  var carouselIntervals = new Map();

  console.log('🎠 Carousel Auto-Scroll Script Loaded');

  function startCarouselAutoScroll(carousel) {
    console.log('🔄 Attempting to start carousel:', carousel);
    
    if (carouselIntervals.has(carousel)) {
      console.log('⚠️ Carousel already initialized, skipping');
      return;
    }

    var nextButton = carousel.querySelector(':scope > slideshow-container > slideshow-arrows > .slideshow-control--next');
    var prevButton = carousel.querySelector(':scope > slideshow-container > slideshow-arrows > .slideshow-control--previous');
    
    console.log('🔘 Next button found:', nextButton);
    console.log('🔘 Prev button found:', prevButton);
    
    if (!nextButton) {
      console.log('❌ No next button found, aborting');
      return;
    }

    var intervalId = setInterval(function() {
      // Get only direct child slides of this carousel (not nested product image slides)
      var slidesContainer = carousel.querySelector(':scope > slideshow-container > slideshow-slides');
      var slides = slidesContainer ? slidesContainer.querySelectorAll(':scope > slideshow-slide') : [];
      var currentSlideIndex = -1;
      
      slides.forEach(function(slide, index) {
        if (slide.getAttribute('aria-hidden') === 'false') {
          currentSlideIndex = index;
        }
      });

      console.log('📍 Current slide:', currentSlideIndex, '/ Total slides:', slides.length);

      // Check if next button is disabled (at end)
      var isAtEnd = nextButton.hasAttribute('disabled') || nextButton.disabled;
      
      if (isAtEnd && prevButton) {
        console.log('🔙 At last slide (button disabled), looping back to start');
        // Click previous multiple times to get back to start
        var clickCount = currentSlideIndex;
        for (var i = 0; i < clickCount; i++) {
          setTimeout(function(idx) {
            return function() {
              prevButton.click();
              console.log('⬅️ Clicked previous (step ' + (idx + 1) + ' of ' + clickCount + ')');
            };
          }(i), i * 50); // Small delay between clicks
        }
      } else {
        console.log('➡️ Moving to next slide');
        nextButton.click();
      }
    }, AUTOSCROLL_INTERVAL);

    carouselIntervals.set(carousel, intervalId);
    console.log('✅ Carousel auto-scroll started with interval:', intervalId);

    carousel.addEventListener('mouseenter', function() {
      console.log('⏸️ Mouse entered - pausing');
      var id = carouselIntervals.get(carousel);
      if (id) {
        clearInterval(id);
        carouselIntervals.delete(carousel);
      }
    });

    carousel.addEventListener('mouseleave', function() {
      console.log('▶️ Mouse left - resuming');
      if (!carouselIntervals.has(carousel)) {
        startCarouselAutoScroll(carousel);
      }
    });
  }

  function initAllCarousels() {
    console.log('🔍 Searching for carousels...');
    var carousels = document.querySelectorAll('slideshow-component.resource-list__carousel');
    console.log('📦 Found', carousels.length, 'carousels');
    
    carousels.forEach(function(carousel, index) {
      console.log('🎯 Initializing carousel #' + (index + 1));
      startCarouselAutoScroll(carousel);
    });
  }

  if (document.readyState === 'loading') {
    console.log('⏳ Document still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    console.log('✨ Document already loaded, initializing now');
    initAllCarousels();
  }

  document.addEventListener('shopify:section:load', function() {
    console.log('🔄 Shopify section loaded, re-initializing');
    initAllCarousels();
  });
  
  setTimeout(function() {
    console.log('⏰ Backup initialization after 1 second');
    initAllCarousels();
  }, 1000);
})();